import { useEffect, useRef } from "react";

import { TIME_INTERVALS } from "../constants/time";

type FunctionType = (...args: any[]) => any;

const DEFAULT_TIMEOUT_DELAY = TIME_INTERVALS.ONE_SECOND;

export const useTimeout = (
  callback: FunctionType,
  delay: number = DEFAULT_TIMEOUT_DELAY
) => {
  // Save callback as a ref to avoid re-running timeout every time accidentally
  const callbackRef = useRef<FunctionType>(callback);

  useEffect(() => {
    const timeout = setTimeout(() => {
      callbackRef.current();
    }, delay);

    return () => {
      clearTimeout(timeout);
    };
  }, [delay]);
};
